import {
  Component, Vue,
} from 'vue-property-decorator';
import WithRender from './anonymous-persona.html';
import BasePersona from '../base-persona/BasePersona';
import SharedDataService from '@/modules/shared/services/sharedDataService';
import { Inject } from 'vue-di-container';
import { Personas } from '@/enums/persona';

@WithRender
@Component({
  components: {
    BasePersona,
  },
})
export default class AnonymousPersona extends Vue {
  @Inject(SharedDataService)
  public sharedDataService!:SharedDataService;
  public get Personas() {
    return Personas;
  }
}
